<script>
  import { push } from "svelte-spa-router"
  import notify from "../../../../Script/notify"
  import { releaseDocument } from "../Script/api"
  import BadgePublish, { updateBadgePublish } from "../Stores/badge"
  import ReleaseConfirm from "./releaseConfirm.svelte"

  export let showBackBtn = false

  export let releaseBtn = true
  export let title = ""
  /**
   * @type {String} - Export a variable to control the loading screen massage
   */
  export let msg
  /**
   * @type {Boolean} -  Export a variable to control the state of an API call button
   */
  export let showLoading = false
  /**
   * @type {Boolean} - used to show or hide the release modal
   */
  let showReleaseConfirmationModal = false
  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  export let redirectUrl = "/publish/badge/doctemplate?documentId="

  /**
   * @description - Navigates the user back within a multi-step document publishing process based on the current URL hash. If the current step is recognized, this function redirects the user to the previous step.
   */
  const goBack = () => {
    $BadgePublish.documentTemplateId = ""
    updateBadgePublish($BadgePublish)
    push(`${redirectUrl}${$BadgePublish.documentId}`)
  }

  /**
   * @description Releases a document by making an API call to release its ID.  Handles success and error cases, and updates UI accordingly.
   * @async
   * @function
   * @returns {void}
   */
  const handleBadgeRelease = async () => {
    try {
      msg = "Releasing Badge"
      closeNotification.close()
      showLoading = true
      showReleaseConfirmationModal = false

      await releaseDocument($BadgePublish.documentId)

      localStorage.removeItem("P2BSinglePublish")
      $BadgePublish = {}

      // Show a success notification
      notify.success("Badge <strong>released</strong> Successfully")

      // Navigate back to the initial publishing page
      push("/publish/badge")

      // Update the UI with the latest $SinglePublish data
      updateBadgePublish($BadgePublish)
    } catch (error) {
      const info = "PAGE: Badge Publish (Header)\nEVENT: While releasing document related to badge"
      closeNotification = notify.danger(error, info)
    } finally {
      showLoading = false
    }
  }
</script>

{#if showReleaseConfirmationModal}
  <ReleaseConfirm
    on:click={() => {
      showReleaseConfirmationModal = false
    }}
    on:release={handleBadgeRelease}
  />
{/if}

<div class="mb-3 flex items-end justify-between">
  <div class="space-y-1">
    {#if showBackBtn}
      <button on:click={goBack} type="button" class="w-16 cursor-pointer select-none text-base font-medium text-gray-200 hover:text-blue-600 focus-visible:text-blue-600 focus-visible:outline-none active:text-blue-500" style="text-decoration: none;">
        <span>
          <i class="fa-solid fa-reply" />
          <span>&nbsp;Back&nbsp;</span>
        </span>
      </button>
    {/if}
    <h1 class="select-none text-xl font-bold text-black dark:text-white {window.location.hash.split('?')[0] == `#/publish/badge/doctemplate` || window.location.hash.split('?')[0] == `#/publish/badge/preview` || window.location.hash.split('?')[0] == `#/publish/badge/badgetemplate` || window.location.hash.split('?')[0] == `#/publish/badge/upload` ? 'mt-7' : 'mt-0'} ">
      {title}
    </h1>
  </div>
  <div class="flex items-center gap-3">
    {#if releaseBtn}
      <button
        disabled={showLoading}
        on:click={() => {
          showReleaseConfirmationModal = !showReleaseConfirmationModal
        }}
        type="button"
        tabindex="0"
        data-tooltip="Release document"
        tooltip-position="top"
        class="flex h-9 min-w-[36px] cursor-pointer items-center justify-center rounded-full border border-[#a0a1a580] bg-white px-2 text-sm font-medium text-gray-900 hover:bg-red-600 hover:text-white focus:outline-none focus-visible:bg-red-600 focus-visible:text-white focus-visible:outline-none active:bg-red-500 disabled:cursor-not-allowed dark:bg-black dark:text-white dark:hover:bg-red-600"
      >
        <i class="fa-solid fa-trash-can" />
      </button>
    {/if}
  </div>
</div>
